import { BaseDataLayerItem } from '/@/integrations/googletagmanager/models/BaseDataLayerItem';

export class HotjarIdentifyDataLayerItem extends BaseDataLayerItem {
  userId?: number;
  name?: string;
  email?: string;
  role?: string;
  assignedEstateProfessionals?: string;
  metricData: Record<string, string>;
  billingPlan?: string;
  daysSinceSignup?: number | null;
  daysSinceLastLogin?: number | null;
  estateStatus?: string;
  guidanceStage?: string;
  payingCustomer?: boolean;
  jurisdiction?: string;
  estateId?: number;
  estateName?: string;
  product?: string;
  referralPartner?: string;
  language?: string;
  createdAt?: string;
  daysSinceAccountCreated?: number;
  city?: string;
  country?: string;
  maritalStatus?: string;
  guidanceRequested?: string;

  constructor(model: Partial<HotjarIdentifyDataLayerItem> = {}) {
    super(model);

    this.userId = model.userId;
    this.name = model.name;
    this.email = model.email;
    this.role = model.role;
    this.billingPlan = model.billingPlan;
    this.assignedEstateProfessionals = this.getEmailPrefix(model.assignedEstateProfessionals);
    this.metricData = model.metricData ?? {};
    this.daysSinceSignup = model.daysSinceSignup;
    this.daysSinceLastLogin = model.daysSinceLastLogin;
    this.estateStatus = model.estateStatus;
    this.guidanceStage = model.guidanceStage;
    this.payingCustomer = model.payingCustomer;
    this.jurisdiction = model.jurisdiction;
    this.estateId = model.estateId;
    this.estateName = model.estateName;
    this.product = model.product;
    this.referralPartner = model.referralPartner;
    this.language = model.language;
    this.createdAt = model.createdAt;
    this.daysSinceAccountCreated = model.daysSinceAccountCreated;
    this.city = model.city;
    this.country = model.country;
    this.maritalStatus = model.maritalStatus;
    this.guidanceRequested = model.guidanceRequested;
  }

  /**
   * Hotjar does not accept emails to be sent over, so we are sending only the first part of the email.
   * In automations, we would add `@example.com` to it.
   * They also don't accept objects.
   */
  private getEmailPrefix(emails?: string[] | string): string {
    if (!Array.isArray(emails)) {
      return emails ?? '';
    }

    return emails.map((email: string) => email.split('@')[0]).join(', ');
  }
}
